import { AnimationRefs } from '../../../hooks/use-animation-refs';
import { Viewport } from '../../../hooks/use-viewport';
import { animateStars } from '../../helpers/animate-stars';

export function build(tl: GSAPTimeline, refs: AnimationRefs, viewport: Viewport) {
  const { vw, vh } = viewport;

  tl.call(
    () => {
      refs.pointsScreen.current?.dispatchEvent(new CustomEvent('pointsScreen:show'));
    },
    [],
    'pointsScreen'
  );

  tl.to(refs.pointsScreen.current, { opacity: 1, y: 0, duration: 0.7, zIndex: 4 }, 'pointsScreen')
    .to(refs.mainPrayer.container.current, { opacity: 0, y: vh(0.18), duration: 0.7 }, 'pointsScreen')
    .to(refs.buttons.action.current, { scale: 0.75, x: -19, duration: 0.7 }, 'pointsScreen')
    .to(refs.buttons.decor.current, { scale: 0.75, x: 19, duration: 0.7 }, 'pointsScreen')
    .to(
      refs.blobs.pink.current,
      { width: vw(0.9), height: vh(0.26), x: vw(0.27), y: vh(0.15), duration: 0.7 },
      'pointsScreen'
    )
    .to(
      refs.blobs.cyan.current,
      { width: vw(1.24), height: vh(0.58), x: vw(-0.51), y: vh(0.47), duration: 0.7 },
      'pointsScreen'
    );

  animateStars({
    tl,
    stars: refs.stars,
    label: 'pointsScreen',
    animations: [
      { alpha: 0, duration: 0.7 },
      { alpha: 0, duration: 0.7 },
      { alpha: 0, duration: 0.7 },
      { alpha: 0, duration: 0.7 },
      { alpha: 0, duration: 0.7 },
      { alpha: 0, duration: 0.7 },
      { alpha: 0, duration: 0.7 },
    ],
  });
}
